import { IPowerbarStoreModule, registerAdapter, unregisterAdapter } from '../utils';
import { IFundSearchState } from './types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import state from './state';

const FundSearchState: IPowerbarStoreModule<IFundSearchState, any> = {
  name: 'FundSearchState',
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
FundSearchState.register = registerAdapter(FundSearchState);
FundSearchState.unregister = unregisterAdapter(FundSearchState);

export default FundSearchState;
